import { render, staticRenderFns } from "./SignupPatientForm.vue?vue&type=template&id=71e52b7a"
import script from "./SignupPatientForm.vue?vue&type=script&lang=js"
export * from "./SignupPatientForm.vue?vue&type=script&lang=js"
import style0 from "./SignupPatientForm.vue?vue&type=style&index=0&id=71e52b7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports